define('services/queueAdmin/wrapupCodeService',[
    'lib/lodash4',
    'services/apiCore'
], function (_, apiCore) {
    'use strict';

    var BASE_URI = '/routing/queues/';
    var BASE_WRAPUP_URI = '/routing/wrapupcodes';
    var BASE_WRAPUP_URI_DIVISION_VIEW = '/routing/wrapupcodes/divisionviews';

    var buildWrapupCodesUri = function(queueId) {
        return BASE_URI + queueId + "/wrapupcodes";
    };

    return {
        getWrapupCodes: function(options) {
            return apiCore.v2.get(BASE_WRAPUP_URI, options);
        },
        getWrapupCodesForAllDivisions: function(options) {
            return apiCore.v2.get(BASE_WRAPUP_URI_DIVISION_VIEW, options);
        },
        getWrapupCodesForQueue: function (options, queueId) {
            options = _.assign({ pageSize: 100, pageNumber: 1 }, options);
            return apiCore.v2.get(buildWrapupCodesUri(queueId), options);
        },
        getWrapupCodeById: function (id) {
            return apiCore.v2.get(BASE_WRAPUP_URI + "/" + id);
        }
    };
});

